module.exports = __webpack_public_path__ + "img/CV.4a62ca6e.svg";